export interface ICountryCode {
  names: any;
  dial_code: string;
  code: string;
}

export const COUNTRY_CODES: ICountryCode[] = [
  { names: { en: 'Afghanistan', pl: 'Afganistan' }, dial_code: '+93', code: 'AF' },
  { names: { en: 'Aland Islands', pl: 'Wyspy Alandzkie' }, dial_code: '+358', code: 'AX' },
  { names: { en: 'Albania', pl: 'Albania' }, dial_code: '+355', code: 'AL' },
  { names: { en: 'Algeria', pl: 'Algieria' }, dial_code: '+213', code: 'DZ' },
  { names: { en: 'American Samoa', pl: 'Samoa Amerykańskie' }, dial_code: '+1684', code: 'AS' },
  { names: { en: 'Andorra', pl: 'Andora' }, dial_code: '+376', code: 'AD' },
  { names: { en: 'Angola', pl: 'Angola' }, dial_code: '+244', code: 'AO' },
  { names: { en: 'Anguilla', pl: 'Anguilla' }, dial_code: '+1264', code: 'AI' },
  { names: { en: 'Antarctica', pl: 'Antarktyka' }, dial_code: '+672', code: 'AQ' },
  { names: { en: 'Antigua and Barbuda', pl: 'Antigua i Barbuda' }, dial_code: '+1268', code: 'AG' },
  { names: { en: 'Argentina', pl: 'Argentyna' }, dial_code: '+54', code: 'AR' },
  { names: { en: 'Armenia', pl: 'Armenia' }, dial_code: '+374', code: 'AM' },
  { names: { en: 'Aruba', pl: 'Aruba' }, dial_code: '+297', code: 'AW' },
  { names: { en: 'Australia', pl: 'Australia' }, dial_code: '+61', code: 'AU' },
  { names: { en: 'Austria', pl: 'Austria' }, dial_code: '+43', code: 'AT' },
  { names: { en: 'Azerbaijan', pl: 'Azerbejdżan' }, dial_code: '+994', code: 'AZ' },
  { names: { en: 'Bahamas', pl: 'Bahamy' }, dial_code: '+1242', code: 'BS' },
  { names: { en: 'Bahrain', pl: 'Bahrajn' }, dial_code: '+973', code: 'BH' },
  { names: { en: 'Bangladesh', pl: 'Bangladesz' }, dial_code: '+880', code: 'BD' },
  { names: { en: 'Barbados', pl: 'Barbados' }, dial_code: '+1246', code: 'BB' },
  { names: { en: 'Belarus', pl: 'Białoruś' }, dial_code: '+375', code: 'BY' },
  { names: { en: 'Belgium', pl: 'Belgia' }, dial_code: '+32', code: 'BE' },
  { names: { en: 'Belize', pl: 'Belize' }, dial_code: '+501', code: 'BZ' },
  { names: { en: 'Benin', pl: 'Benin' }, dial_code: '+229', code: 'BJ' },
  { names: { en: 'Bermuda', pl: 'Bermudy' }, dial_code: '+1441', code: 'BM' },
  { names: { en: 'Bhutan', pl: 'Bhutan' }, dial_code: '+975', code: 'BT' },
  {
    names: { en: 'Bolivia, Plurinational State of', pl: 'Boliwia' },
    dial_code: '+591',
    code: 'BO',
  },
  {
    names: { en: 'Bosnia and Herzegovina', pl: 'Bośnia i Hercegowina' },
    dial_code: '+387',
    code: 'BA',
  },
  { names: { en: 'Botswana', pl: 'Botswana' }, dial_code: '+267', code: 'BW' },
  { names: { en: 'Brazil', pl: 'Brazylia' }, dial_code: '+55', code: 'BR' },
  {
    names: { en: 'British Indian Ocean Territory', pl: 'Brytyjskie Terytorium Oceanu Indyjskiego' },
    dial_code: '+246',
    code: 'IO',
  },
  { names: { en: 'Brunei Darussalam', pl: 'Brunei' }, dial_code: '+673', code: 'BN' },
  { names: { en: 'Bulgaria', pl: 'Bułgaria' }, dial_code: '+359', code: 'BG' },
  { names: { en: 'Burkina Faso', pl: 'Burkina Faso' }, dial_code: '+226', code: 'BF' },
  { names: { en: 'Burundi', pl: 'Burundi' }, dial_code: '+257', code: 'BI' },
  { names: { en: 'Cambodia', pl: 'Kambodża' }, dial_code: '+855', code: 'KH' },
  { names: { en: 'Cameroon', pl: 'Kamerun' }, dial_code: '+237', code: 'CM' },
  { names: { en: 'Canada', pl: 'Kanada' }, dial_code: '+1', code: 'CA' },
  { names: { en: 'Cape Verde', pl: 'Wyspy Zielonego Przylądka' }, dial_code: '+238', code: 'CV' },
  { names: { en: 'Cayman Islands', pl: 'Kajmany' }, dial_code: '+ 345', code: 'KY' },
  {
    names: { en: 'Central African Republic', pl: 'Republika Środkowoafrykańska' },
    dial_code: '+236',
    code: 'CF',
  },
  { names: { en: 'Chad', pl: 'Czad' }, dial_code: '+235', code: 'TD' },
  { names: { en: 'Chile', pl: 'Chile' }, dial_code: '+56', code: 'CL' },
  { names: { en: 'China', pl: 'Chiny' }, dial_code: '+86', code: 'CN' },
  {
    names: { en: 'Christmas Island', pl: 'Wyspa Bożego Narodzenia' },
    dial_code: '+61',
    code: 'CX',
  },
  { names: { en: 'Cocos (Keeling) Islands', pl: 'Wyspy Kokosowe' }, dial_code: '+61', code: 'CC' },
  { names: { en: 'Colombia', pl: 'Kolumbia' }, dial_code: '+57', code: 'CO' },
  { names: { en: 'Comoros', pl: 'Związek Komorów' }, dial_code: '+269', code: 'KM' },
  { names: { en: 'Congo', pl: 'Kongo' }, dial_code: '+242', code: 'CG' },
  {
    names: {
      en: 'Congo, The Democratic Republic of the Congo',
      pl: 'Demokratyczna Republika Konga',
    },
    dial_code: '+243',
    code: 'CD',
  },
  { names: { en: 'Cook Islands', pl: 'Wyspy Cooka' }, dial_code: '+682', code: 'CK' },
  { names: { en: 'Costa Rica', pl: 'Kostaryka' }, dial_code: '+506', code: 'CR' },
  { names: { en: "Cote d'Ivoire", pl: 'Wybrzeże Kości Słoniowej' }, dial_code: '+225', code: 'CI' },
  { names: { en: 'Croatia', pl: 'Chorwacja' }, dial_code: '+385', code: 'HR' },
  { names: { en: 'Cuba', pl: 'Kuba' }, dial_code: '+53', code: 'CU' },
  { names: { en: 'Cyprus', pl: 'Cypr' }, dial_code: '+357', code: 'CY' },
  { names: { en: 'Czech Republic', pl: 'Czechy' }, dial_code: '+420', code: 'CZ' },
  { names: { en: 'Denmark', pl: 'Dania' }, dial_code: '+45', code: 'DK' },
  { names: { en: 'Djibouti', pl: 'Dżibuti' }, dial_code: '+253', code: 'DJ' },
  { names: { en: 'Dominica', pl: 'Dominika' }, dial_code: '+1767', code: 'DM' },
  { names: { en: 'Dominican Republic', pl: 'Dominikana' }, dial_code: '+1849', code: 'DO' },
  { names: { en: 'Ecuador', pl: 'Ekwador' }, dial_code: '+593', code: 'EC' },
  { names: { en: 'Egypt', pl: 'Egipt' }, dial_code: '+20', code: 'EG' },
  { names: { en: 'El Salvador', pl: 'Salwador' }, dial_code: '+503', code: 'SV' },
  { names: { en: 'Equatorial Guinea', pl: 'Gwinea Równikowa' }, dial_code: '+240', code: 'GQ' },
  { names: { en: 'Eritrea', pl: 'Erytrea' }, dial_code: '+291', code: 'ER' },
  { names: { en: 'Estonia', pl: 'Estonia' }, dial_code: '+372', code: 'EE' },
  { names: { en: 'Ethiopia', pl: 'Etiopia' }, dial_code: '+251', code: 'ET' },
  { names: { en: 'Falkland Islands (Malvinas)', pl: 'Falklandy' }, dial_code: '+500', code: 'FK' },
  { names: { en: 'Faroe Islands', pl: 'Wyspy Owcze' }, dial_code: '+298', code: 'FO' },
  { names: { en: 'Fiji', pl: 'Fidżi' }, dial_code: '+679', code: 'FJ' },
  { names: { en: 'Finland', pl: 'Finlandia' }, dial_code: '+358', code: 'FI' },
  { names: { en: 'France', pl: 'Francja' }, dial_code: '+33', code: 'FR' },
  { names: { en: 'French Guiana', pl: 'Gujana Francuska' }, dial_code: '+594', code: 'GF' },
  { names: { en: 'French Polynesia', pl: 'Polinezja Francuska' }, dial_code: '+689', code: 'PF' },
  { names: { en: 'Gabon', pl: 'Gabon' }, dial_code: '+241', code: 'GA' },
  { names: { en: 'Gambia', pl: 'Gambia' }, dial_code: '+220', code: 'GM' },
  { names: { en: 'Georgia', pl: 'Gruzja' }, dial_code: '+995', code: 'GE' },
  { names: { en: 'Germany', pl: 'Niemcy' }, dial_code: '+49', code: 'DE' },
  { names: { en: 'Ghana', pl: 'Ghana' }, dial_code: '+233', code: 'GH' },
  { names: { en: 'Gibraltar', pl: 'Gibraltar' }, dial_code: '+350', code: 'GI' },
  { names: { en: 'Greece', pl: 'Grecja' }, dial_code: '+30', code: 'GR' },
  { names: { en: 'Greenland', pl: 'Grenlandia' }, dial_code: '+299', code: 'GL' },
  { names: { en: 'Grenada', pl: 'Grenada' }, dial_code: '+1473', code: 'GD' },
  { names: { en: 'Guadeloupe', pl: 'Gwadelupa' }, dial_code: '+590', code: 'GP' },
  { names: { en: 'Guam', pl: 'Guam' }, dial_code: '+1671', code: 'GU' },
  { names: { en: 'Guatemala', pl: 'Gwatemala' }, dial_code: '+502', code: 'GT' },
  { names: { en: 'Guernsey', pl: 'Guersney' }, dial_code: '+44', code: 'GG' },
  { names: { en: 'Guinea', pl: 'Gwinea' }, dial_code: '+224', code: 'GN' },
  { names: { en: 'Guinea-Bissau', pl: 'Gwinea Bissau' }, dial_code: '+245', code: 'GW' },
  { names: { en: 'Guyana', pl: 'Gujana' }, dial_code: '+595', code: 'GY' },
  { names: { en: 'Haiti', pl: 'Haiti' }, dial_code: '+509', code: 'HT' },
  { names: { en: 'Holy See (Vatican City State)', pl: 'Watykan' }, dial_code: '+379', code: 'VA' },
  { names: { en: 'Honduras', pl: 'Honduras' }, dial_code: '+504', code: 'HN' },
  { names: { en: 'Hong Kong', pl: 'Hong Kong' }, dial_code: '+852', code: 'HK' },
  { names: { en: 'Hungary', pl: 'Węgry' }, dial_code: '+36', code: 'HU' },
  { names: { en: 'Iceland', pl: 'Islandia' }, dial_code: '+354', code: 'IS' },
  { names: { en: 'India', pl: 'Indie' }, dial_code: '+91', code: 'IN' },
  { names: { en: 'Indonesia', pl: 'Indonezja' }, dial_code: '+62', code: 'ID' },
  {
    names: { en: 'Iran, Islamic Republic of Persian Gulf', pl: 'Iran' },
    dial_code: '+98',
    code: 'IR',
  },
  { names: { en: 'Iraq', pl: 'Irak' }, dial_code: '+964', code: 'IQ' },
  { names: { en: 'Ireland', pl: 'Irlandia' }, dial_code: '+353', code: 'IE' },
  { names: { en: 'Isle of Man', pl: 'Wyspa Man' }, dial_code: '+44', code: 'IM' },
  { names: { en: 'Israel', pl: 'Izrael' }, dial_code: '+972', code: 'IL' },
  { names: { en: 'Italy', pl: 'Włochy' }, dial_code: '+39', code: 'IT' },
  { names: { en: 'Jamaica', pl: 'Jamajka' }, dial_code: '+1876', code: 'JM' },
  { names: { en: 'Japan', pl: 'Japonia' }, dial_code: '+81', code: 'JP' },
  { names: { en: 'Jersey', pl: 'Jersey' }, dial_code: '+44', code: 'JE' },
  { names: { en: 'Jordan', pl: 'Jordania' }, dial_code: '+962', code: 'JO' },
  { names: { en: 'Kazakhstan', pl: 'Kazachstan' }, dial_code: '+77', code: 'KZ' },
  { names: { en: 'Kenya', pl: 'Kenia' }, dial_code: '+254', code: 'KE' },
  { names: { en: 'Kiribati', pl: 'Kiribati' }, dial_code: '+686', code: 'KI' },
  {
    names: { en: "Korea, Democratic People's Republic of Korea", pl: 'Korea Północna' },
    dial_code: '+850',
    code: 'KP',
  },
  {
    names: { en: 'Korea, Republic of South Korea', pl: 'Korea Południowa' },
    dial_code: '+82',
    code: 'KR',
  },
  { names: { en: 'Kuwait', pl: 'Kuwejt' }, dial_code: '+965', code: 'KW' },
  { names: { en: 'Kyrgyzstan', pl: 'Kirgistan' }, dial_code: '+996', code: 'KG' },
  { names: { en: 'Laos', pl: 'Laos' }, dial_code: '+856', code: 'LA' },
  { names: { en: 'Latvia', pl: 'Łotwa' }, dial_code: '+371', code: 'LV' },
  { names: { en: 'Lebanon', pl: 'Liban' }, dial_code: '+961', code: 'LB' },
  { names: { en: 'Lesotho', pl: 'Lesotho' }, dial_code: '+266', code: 'LS' },
  { names: { en: 'Liberia', pl: 'Liberia' }, dial_code: '+231', code: 'LR' },
  { names: { en: 'Libyan Arab Jamahiriya', pl: 'Libia' }, dial_code: '+218', code: 'LY' },
  { names: { en: 'Liechtenstein', pl: 'Lichtenstein' }, dial_code: '+423', code: 'LI' },
  { names: { en: 'Lithuania', pl: 'Litwa' }, dial_code: '+370', code: 'LT' },
  { names: { en: 'Luxembourg', pl: 'Luksemburg' }, dial_code: '+352', code: 'LU' },
  { names: { en: 'Macao', pl: 'Makau' }, dial_code: '+853', code: 'MO' },
  { names: { en: 'Macedonia', pl: 'Macedonia' }, dial_code: '+389', code: 'MK' },
  { names: { en: 'Madagascar', pl: 'Madagaskar' }, dial_code: '+261', code: 'MG' },
  { names: { en: 'Malawi', pl: 'Malawi' }, dial_code: '+265', code: 'MW' },
  { names: { en: 'Malaysia', pl: 'Malezja' }, dial_code: '+60', code: 'MY' },
  { names: { en: 'Maldives', pl: 'Malediwy' }, dial_code: '+960', code: 'MV' },
  { names: { en: 'Mali', pl: 'Mali' }, dial_code: '+223', code: 'ML' },
  { names: { en: 'Malta', pl: 'Malta' }, dial_code: '+356', code: 'MT' },
  { names: { en: 'Marshall Islands', pl: 'Wyspy Marshalla' }, dial_code: '+692', code: 'MH' },
  { names: { en: 'Martinique', pl: 'Martynika' }, dial_code: '+596', code: 'MQ' },
  { names: { en: 'Mauritania', pl: 'Mauretania' }, dial_code: '+222', code: 'MR' },
  { names: { en: 'Mauritius', pl: 'Mauritius' }, dial_code: '+230', code: 'MU' },
  { names: { en: 'Mayotte', pl: 'Majotta' }, dial_code: '+262', code: 'YT' },
  { names: { en: 'Mexico', pl: 'Meksyk' }, dial_code: '+52', code: 'MX' },
  {
    names: { en: 'Micronesia, Federated States of Micronesia', pl: 'Mikronezja' },
    dial_code: '+691',
    code: 'FM',
  },
  { names: { en: 'Moldova', pl: 'Mołdawia' }, dial_code: '+373', code: 'MD' },
  { names: { en: 'Monaco', pl: 'Monako' }, dial_code: '+377', code: 'MC' },
  { names: { en: 'Mongolia', pl: 'Mongolia' }, dial_code: '+976', code: 'MN' },
  { names: { en: 'Montenegro', pl: 'Czarnogóra' }, dial_code: '+382', code: 'ME' },
  { names: { en: 'Montserrat', pl: 'Montserrat' }, dial_code: '+1664', code: 'MS' },
  { names: { en: 'Morocco', pl: 'Maroko' }, dial_code: '+212', code: 'MA' },
  { names: { en: 'Mozambique', pl: 'Mozambik' }, dial_code: '+258', code: 'MZ' },
  { names: { en: 'Myanmar', pl: 'Birma' }, dial_code: '+95', code: 'MM' },
  { names: { en: 'Namibia', pl: 'Namibia' }, dial_code: '+264', code: 'NA' },
  { names: { en: 'Nauru', pl: 'Nauru' }, dial_code: '+674', code: 'NR' },
  { names: { en: 'Nepal', pl: 'Nepal' }, dial_code: '+977', code: 'NP' },
  { names: { en: 'Netherlands', pl: 'Holandia' }, dial_code: '+31', code: 'NL' },
  {
    names: { en: 'Netherlands Antilles', pl: 'Antyle Holenderskie' },
    dial_code: '+599',
    code: 'AN',
  },
  { names: { en: 'New Caledonia', pl: 'Nowa Kaledonia' }, dial_code: '+687', code: 'NC' },
  { names: { en: 'New Zealand', pl: 'Nowa Zelandia' }, dial_code: '+64', code: 'NZ' },
  { names: { en: 'Nicaragua', pl: 'Nikaragua' }, dial_code: '+505', code: 'NI' },
  { names: { en: 'Niger', pl: 'Niger' }, dial_code: '+227', code: 'NE' },
  { names: { en: 'Nigeria', pl: 'Nigeria' }, dial_code: '+234', code: 'NG' },
  { names: { en: 'Niue', pl: 'Niue' }, dial_code: '+683', code: 'NU' },
  { names: { en: 'Norfolk Island', pl: 'Wyspa Norfolk' }, dial_code: '+672', code: 'NF' },
  {
    names: { en: 'Northern Mariana Islands', pl: 'Mariany Północne' },
    dial_code: '+1670',
    code: 'MP',
  },
  { names: { en: 'Norway', pl: 'Norwegia' }, dial_code: '+47', code: 'NO' },
  { names: { en: 'Oman', pl: 'Oman' }, dial_code: '+968', code: 'OM' },
  { names: { en: 'Pakistan', pl: 'Pakistan' }, dial_code: '+92', code: 'PK' },
  { names: { en: 'Palau', pl: 'Palau' }, dial_code: '+680', code: 'PW' },
  {
    names: { en: 'Palestinian Territory, Occupied', pl: 'Terytoria Palestyńskie' },
    dial_code: '+970',
    code: 'PS',
  },
  { names: { en: 'Panama', pl: 'Panama' }, dial_code: '+507', code: 'PA' },
  { names: { en: 'Papua New Guinea', pl: 'Papua Nowa Gwinea' }, dial_code: '+675', code: 'PG' },
  { names: { en: 'Paraguay', pl: 'Paragwaj' }, dial_code: '+595', code: 'PY' },
  { names: { en: 'Peru', pl: 'Peru' }, dial_code: '+51', code: 'PE' },
  { names: { en: 'Philippines', pl: 'Filipiny' }, dial_code: '+63', code: 'PH' },
  { names: { en: 'Pitcairn', pl: 'Pitcairn' }, dial_code: '+872', code: 'PN' },
  { names: { en: 'Poland', pl: 'Polska' }, dial_code: '+48', code: 'PL' },
  { names: { en: 'Portugal', pl: 'Portugalia' }, dial_code: '+351', code: 'PT' },
  { names: { en: 'Puerto Rico', pl: 'Portoryko' }, dial_code: '+1939', code: 'PR' },
  { names: { en: 'Qatar', pl: 'Katar' }, dial_code: '+974', code: 'QA' },
  { names: { en: 'Romania', pl: 'Rumunia' }, dial_code: '+40', code: 'RO' },
  { names: { en: 'Russia', pl: 'Rosja' }, dial_code: '+7', code: 'RU' },
  { names: { en: 'Rwanda', pl: 'Rwanda' }, dial_code: '+250', code: 'RW' },
  { names: { en: 'Reunion', pl: 'Reunion' }, dial_code: '+262', code: 'RE' },
  { names: { en: 'Saint Barthelemy', pl: 'Saint Barthelemy' }, dial_code: '+590', code: 'BL' },
  {
    names: { en: 'Saint Helena, Ascension and Tristan Da Cunha', pl: 'Święta Helena' },
    dial_code: '+290',
    code: 'SH',
  },
  {
    names: { en: 'Saint Kitts and Nevis', pl: 'Sain Kitts i Nevis' },
    dial_code: '+1869',
    code: 'KN',
  },
  { names: { en: 'Saint Lucia', pl: 'Saint Lucia' }, dial_code: '+1758', code: 'LC' },
  { names: { en: 'Saint Martin', pl: 'Saint Maarten' }, dial_code: '+590', code: 'MF' },
  {
    names: { en: 'Saint Pierre and Miquelon', pl: 'Saint Pierre i Miquelon' },
    dial_code: '+508',
    code: 'PM',
  },
  {
    names: { en: 'Saint Vincent and the Grenadines', pl: 'Saint Vincent i Grenadyny' },
    dial_code: '+1784',
    code: 'VC',
  },
  { names: { en: 'Samoa', pl: 'Samoa' }, dial_code: '+685', code: 'WS' },
  { names: { en: 'San Marino', pl: 'San Marino' }, dial_code: '+378', code: 'SM' },
  {
    names: { en: 'Sao Tome and Principe', pl: 'Wyspa Świętego Tomasza i Książęca' },
    dial_code: '+239',
    code: 'ST',
  },
  { names: { en: 'Saudi Arabia', pl: 'Arabia Saudyjska' }, dial_code: '+966', code: 'SA' },
  { names: { en: 'Senegal', pl: 'Senegal' }, dial_code: '+221', code: 'SN' },
  { names: { en: 'Serbia', pl: 'Serbia' }, dial_code: '+381', code: 'RS' },
  { names: { en: 'Seychelles', pl: 'Seszele' }, dial_code: '+248', code: 'SC' },
  { names: { en: 'Sierra Leone', pl: 'Sierra Leone' }, dial_code: '+232', code: 'SL' },
  { names: { en: 'Singapore', pl: 'Singapur' }, dial_code: '+65', code: 'SG' },
  { names: { en: 'Slovakia', pl: 'Słowacja' }, dial_code: '+421', code: 'SK' },
  { names: { en: 'Slovenia', pl: 'Słowenia' }, dial_code: '+386', code: 'SI' },
  { names: { en: 'Solomon Islands', pl: 'Wyspy Salomona' }, dial_code: '+677', code: 'SB' },
  { names: { en: 'Somalia', pl: 'Somalia' }, dial_code: '+252', code: 'SO' },
  {
    names: { en: 'South Africa', pl: 'Republika Południowej Afryki' },
    dial_code: '+27',
    code: 'ZA',
  },
  { names: { en: 'South Sudan', pl: 'Sudan Południowy' }, dial_code: '+211', code: 'SS' },
  {
    names: {
      en: 'South Georgia and the South Sandwich Islands',
      pl: 'Georgia Południowa i Sandwich Południowy',
    },
    dial_code: '+500',
    code: 'GS',
  },
  { names: { en: 'Spain', pl: 'Hiszpania' }, dial_code: '+34', code: 'ES' },
  { names: { en: 'Sri Lanka', pl: 'Sri Lanka' }, dial_code: '+94', code: 'LK' },
  { names: { en: 'Sudan', pl: 'Sudan' }, dial_code: '+249', code: 'SD' },
  { names: { en: 'Suriname', pl: 'Surinam' }, dial_code: '+597', code: 'SR' },
  { names: { en: 'Svalbard and Jan Mayen', pl: 'Svalbard' }, dial_code: '+47', code: 'SJ' },
  { names: { en: 'Swaziland', pl: 'Suazi' }, dial_code: '+268', code: 'SZ' },
  { names: { en: 'Sweden', pl: 'Szwecja' }, dial_code: '+46', code: 'SE' },
  { names: { en: 'Switzerland', pl: 'Szwajcaria' }, dial_code: '+41', code: 'CH' },
  { names: { en: 'Syrian Arab Republic', pl: 'Syria' }, dial_code: '+963', code: 'SY' },
  { names: { en: 'Taiwan', pl: 'Tajwan' }, dial_code: '+886', code: 'TW' },
  { names: { en: 'Tajikistan', pl: 'Tadżykistan' }, dial_code: '+992', code: 'TJ' },
  {
    names: { en: 'Tanzania, United Republic of Tanzania', pl: 'Tanzania' },
    dial_code: '+255',
    code: 'TZ',
  },
  { names: { en: 'Thailand', pl: 'Tajlandia' }, dial_code: '+66', code: 'TH' },
  { names: { en: 'Timor-Leste', pl: 'Timor Wschodni' }, dial_code: '+670', code: 'TL' },
  { names: { en: 'Togo', pl: 'Togo' }, dial_code: '+228', code: 'TG' },
  { names: { en: 'Tokelau', pl: 'Tokelau' }, dial_code: '+690', code: 'TK' },
  { names: { en: 'Tonga', pl: 'Tonga' }, dial_code: '+676', code: 'TO' },
  { names: { en: 'Trinidad and Tobago', pl: 'Trynidad i Tobago' }, dial_code: '+1868', code: 'TT' },
  { names: { en: 'Tunisia', pl: 'Tunezja' }, dial_code: '+216', code: 'TN' },
  { names: { en: 'Turkey', pl: 'Turcja' }, dial_code: '+90', code: 'TR' },
  { names: { en: 'Turkmenistan', pl: 'Turkmenistan' }, dial_code: '+993', code: 'TM' },
  {
    names: { en: 'Turks and Caicos Islands', pl: 'Turks i Caicos' },
    dial_code: '+1649',
    code: 'TC',
  },
  { names: { en: 'Tuvalu', pl: 'Tuvalu' }, dial_code: '+688', code: 'TV' },
  { names: { en: 'Uganda', pl: 'Uganda' }, dial_code: '+256', code: 'UG' },
  { names: { en: 'Ukraine', pl: 'Ukraina' }, dial_code: '+380', code: 'UA' },
  {
    names: { en: 'United Arab Emirates', pl: 'Zjednoczone Emiraty Arabskie' },
    dial_code: '+971',
    code: 'AE',
  },
  { names: { en: 'United Kingdom', pl: 'Wielka Brytania' }, dial_code: '+44', code: 'GB' },
  { names: { en: 'United States', pl: 'Stany Zjednoczone' }, dial_code: '+1', code: 'US' },
  { names: { en: 'Uruguay', pl: 'Urugwaj' }, dial_code: '+598', code: 'UY' },
  { names: { en: 'Uzbekistan', pl: 'Uzbekistan' }, dial_code: '+998', code: 'UZ' },
  { names: { en: 'Vanuatu', pl: 'Vanuatu' }, dial_code: '+678', code: 'VU' },
  {
    names: { en: 'Venezuela, Bolivarian Republic of Venezuela', pl: 'Wenezuela' },
    dial_code: '+58',
    code: 'VE',
  },
  { names: { en: 'Vietnam', pl: 'Wietnam' }, dial_code: '+84', code: 'VN' },
  {
    names: { en: 'Virgin Islands, British', pl: 'Brytyjskie Wyspy Dziewicze' },
    dial_code: '+1284',
    code: 'VG',
  },
  { names: { en: 'Virgin Islands, U.S.', pl: 'Wyspy Dziewicze' }, dial_code: '+1340', code: 'VI' },
  { names: { en: 'Wallis and Futuna', pl: 'Wallis i Futuna' }, dial_code: '+681', code: 'WF' },
  { names: { en: 'Yemen', pl: 'Jemen' }, dial_code: '+967', code: 'YE' },
  { names: { en: 'Zambia', pl: 'Zambia' }, dial_code: '+260', code: 'ZM' },
  { names: { en: 'Zimbabwe', pl: 'Zimbabwe' }, dial_code: '+263', code: 'ZW' },
];
